export class MainImageVideo {
    private static readonly VIDEO_PARENT_ID = 'js_pdp_main-image__video';

    private readonly assetKey: string;
    private loaded = false;

    private videoWrapperElement: HTMLElement;

    constructor(assetKey: string, targetElement: HTMLElement) {
        this.assetKey = assetKey;

        this.videoWrapperElement = document.createElement('div');
        this.videoWrapperElement.classList.add('pdp_main-image__video-wrapper');
        this.videoWrapperElement.innerHTML = `<div id="${MainImageVideo.VIDEO_PARENT_ID}" class="pdp_main-image__video"></div>`;

        targetElement.appendChild(this.videoWrapperElement);
    }

    public pause() {
        this.emitPauseEvent();
    }

    public init() {
        if (!this.loaded) {
            this.emitInitEvent();
            this.loaded = true;
        }
    }

    private emitPauseEvent() {
        o_global.eventQBus.emit('ft5.pdp-video.pause', {
            parentId: MainImageVideo.VIDEO_PARENT_ID,
        });
    }

    private emitInitEvent() {
        o_global.eventQBus.emit('ft5.pdp-video.init', {
            assetKey: this.assetKey,
            parentId: MainImageVideo.VIDEO_PARENT_ID,
            backgroundColor: 'transparent',
            stage: { height: '100%' },
            autoplay: false,
            withNextButton: false,
            onAspectRatioChange: (aspectRatio: string) => {
                const [width, height] = aspectRatio.split(':');
                if (width && height) {
                    const relativeVideoHeight = (Number(height) / Number(width)) * 100;
                    this.videoWrapperElement.style.setProperty('--percentage-video-height', String(relativeVideoHeight));
                    this.videoWrapperElement.style.setProperty('--percentage-video-height-with-unit', String(relativeVideoHeight) + '%');
                }
            },
        });
    }
}
